import request from '@/utils/request'



const CurrentUserRouterUrl = process.env.VUE_APP_PROMISSION_API + '/api/Promission/routerMenus?appCode=' + process.env.VUE_APP_CODE;

export function listForRouter(params) {
  return request({
    url: CurrentUserRouterUrl,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/menu/menu.js